module.exports = __webpack_public_path__ + "static/media/auxocoldchainbackground.6664f0b3.png";